const curpFormatter = (value) => (
  value ? value.toString().toUpperCase() : ''
);

export default curpFormatter;
